import React, { useCallback } from 'react';
import pick from 'lodash/pick';

import OnboardingWizardContentWrapper from '../OnboardingWizardWrappers/OnboardingWizardContentWrapper/OnboardingWizardContentWrapper';
import WorkspacesPreview from '../WorkspacesPreview/WorkspacesPreview';
import KudosComponent from './KudosComponent/KudosComponent';
import FormFields from './FormFields/FormFields';
import { blankKudos } from '../../constants';
import { KudosType, WorkspacesType } from '../../types';
import { isKudosExist } from '../../utils';

import './Kudos.scss';

type Props = {
  kudos: KudosType;
  workspaces: WorkspacesType;
  advanceOnboardingState: Function;
};

function Kudos({ kudos: initialKudos, workspaces, advanceOnboardingState }: Props) {
  const handleSubmit = useCallback(
    ({ kudos }) => {
      return advanceOnboardingState({
        kudos: { ...pick(kudos, ['likeThatText', 'workspaceUuid']), gifUrl: kudos.gifUrl?.fixed_width.url },
        video: kudos.likeThatVideo,
      });
    },
    [advanceOnboardingState]
  );
  const formValidate = values => {
    if (!values.currentWorkspace) return { error: true };
    if (!values.kudos.gifUrl && !values.kudos.likeThatText && !values.kudos.likeThatVideo) return { error: true };
    return {};
  };
  return (
    <OnboardingWizardContentWrapper
      initialValues={{
        workspaces,
        currentWorkspace: initialKudos?.workspaceUuid || null,
        kudos: isKudosExist(initialKudos)
          ? {
              ...initialKudos,
              likeThatVideo: initialKudos.likeThatVideo
                ? { ...initialKudos.likeThatVideo, url: initialKudos.likeThatVideo.url || 'url' }
                : null,
              gifUrl: { fixed_width: { url: initialKudos?.gifUrl } },
            }
          : blankKudos,
      }}
      onNextStep={handleSubmit}
      previewSectionContent={<WorkspacesPreview workspaceContent={<KudosComponent />} useFirstWorkspaceIfNull />}
      formValidate={formValidate}
    >
      <div className="kudos scrollbar pl-1">
        <h4 className="padding-right-50">
          Giving kudos allows you to show appreciation. A little kudos goes a long way.
        </h4>
        <FormFields />
      </div>
    </OnboardingWizardContentWrapper>
  );
}

export default Kudos;
